<template>
  <transition name="fade">
    <div v-if="!visible" class="local-dialog-wrapper">
      <div class="local-dialog-mask"></div>
      <div class="local-dialog">
        <div class="dialog-content">
          <div class="dialog-bg">
            <img src="../../assets/image/dialogBg.png" alt="" />
          </div>
          <div class="dialog-text">
            <div class="dialog-title">您未订阅套餐 请订阅后再使用</div>
            <div class="dialog-button">
              <el-button style="height: 36px" type="primary" @click="gosub"
                >前往订阅</el-button
              >
            </div>
            <div class="dialog-text-tip">订阅后联系客服/客户经理办理</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    gosub() {
      this.$router.push({
        path: "/home/setting/subscribe",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.local-dialog-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.local-dialog-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.local-dialog {
  position: relative;
  z-index: 2001;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.dialog-content {
  display: flex;
  cursor: default;
}

.dialog-bg {
  width: 360px;
  height: 341px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 20px 0px 0px 20px;
  }
}

.dialog-text {
  flex: 1;
  display: flex;
  padding: 0 60px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .dialog-title {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
  }
  .dialog-button {
    margin: 32px auto 16px;
  }
  .dialog-text-tip {
    text-align: center;
    font-size: 13px;
    color: #999999;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
